"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var UiStateController_1 = require("../../../../../shared/UiStateController");
var routes_1 = require("../../../../shared/includes/routes");
var SupportPlayerPersonalPromoCodesList_1 = require("./component/SupportPlayerPersonalPromoCodesList");
var SupportPlayerPersonalPromoCodeRequest_1 = require("./component/SupportPlayerPersonalPromoCodeRequest");
var PSupportPlayerPersonalPromoCodesList = /** @class */ (function (_super) {
    __extends(PSupportPlayerPersonalPromoCodesList, _super);
    function PSupportPlayerPersonalPromoCodesList(props) {
        return _super.call(this, props) || this;
    }
    PSupportPlayerPersonalPromoCodesList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                page_size: data.tablePageSize,
                brands_list: data.brands_list,
                all_brands: data.all_brands,
            });
        });
        this.SID_B = this.props.dataBrands.Subscribe("*", function (id, data) {
            _this.setState({
                avail_brands: data.data
            });
        });
        this.setState({
            page_num: 1,
            page_size: this.props.state.getTablePageSize(),
            brands_list: this.props.state.DATA.brands_list,
            all_brands: this.props.state.DATA.all_brands,
            avail_brands: [],
            avail_currency: [],
            edit_mode: "LIST"
        });
        this.props.dataBrands.LoadData();
    };
    PSupportPlayerPersonalPromoCodesList.prototype.componentWillUnmount = function () {
        this.props.state.UnSubscribe(this.SID_STATE);
        this.props.dataBrands.UnSubscribe(this.SID_B);
    };
    PSupportPlayerPersonalPromoCodesList.prototype.onPageConfigChange = function (PageNum, PageSize) {
        var _this = this;
        this.setState({ page_num: PageNum }, function () {
            _this.props.state.setTablePageSize(PageSize, true);
        });
    };
    PSupportPlayerPersonalPromoCodesList.prototype.onOfferFilterChanged = function (allBrands, BrandId, Action) {
        if (Action === "checkbox") {
            this.props.state.setAllBrands(allBrands, true);
        }
        if (Action === "add") {
            this.props.state.addBrand(BrandId, true);
        }
        if (Action === "remove") {
            this.props.state.delBrand(BrandId, true);
        }
    };
    PSupportPlayerPersonalPromoCodesList.prototype.onNewClick = function () {
        this.setState({ edit_mode: "NEW" });
    };
    PSupportPlayerPersonalPromoCodesList.prototype.onGoBackToListClick = function () {
        this.setState({ edit_mode: "LIST" }, function () {
            //this.props.data.LoadData()
        });
    };
    PSupportPlayerPersonalPromoCodesList.prototype.getRenderObject = function () {
        if (this.state.edit_mode === "LIST") {
            return (React.createElement(SupportPlayerPersonalPromoCodesList_1.default, { data: this.props.data, state: this.props.state, onPageConfigChanged: this.onPageConfigChange.bind(this), pageNum: this.state.page_num, pageSize: this.state.page_size, onBrandFilterChanged: this.onOfferFilterChanged.bind(this), allBrands: this.state.all_brands, availBrands: this.state.avail_brands, brandsList: this.state.brands_list, onNewClick: this.onNewClick.bind(this) }));
        }
        if (this.state.edit_mode === "NEW") {
            return (React.createElement(SupportPlayerPersonalPromoCodeRequest_1.default, { data: this.props.data, state: this.props.state, availPromoOffers: this.props.availPromoOffers, onGoBack: this.onGoBackToListClick.bind(this), avail_brands: this.state.avail_brands }));
        }
    };
    PSupportPlayerPersonalPromoCodesList.prototype.render = function () {
        return this.getRenderObject();
    };
    PSupportPlayerPersonalPromoCodesList.getPageDescription = function (state) {
        return {
            icon: "search",
            iconKind: "normal",
            itemId: "item-" + routes_1.routes.page_support_personal_promo + "-id",
            itemTitle: "Перс. промо",
            route: routes_1.routes.page_support_personal_promo,
            docType: UiStateController_1.UIDocumentType.udtRegularPage
        };
    };
    return PSupportPlayerPersonalPromoCodesList;
}(React.Component));
exports.default = PSupportPlayerPersonalPromoCodesList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/support_player_personal_promocodes/ui/PSupportPlayerPersonalPromoCodesList.tsx
// module id = 2585
// module chunks = 0